export default __webpack_public_path__ + "static/media/AnimalsGreen_01.43193bc1.png";